import React from 'react';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import MerchantClickUrlLink from 'core/modules/MerchantClickUrlLink/MerchantClickUrlLink';
import ReadMore from 'core/modules/ReadMore/ReadMore';

import orgConfig from 'org/configs/org.config';

import './HorizontalOffer.scss';

function HorizontalOffer({ offer, config }) {
  const {
    assets, couponCode, merchant, isOngoing, codeText, expiresToDisplay, disclaimer,
  } = offer;
  const { extraRewardsName } = orgConfig;
  const { rebateOptions } = config;
  const {
    rebate, logoUrls, name, id,
  } = merchant;

  return (
    <div className="mn_horizontalOffer mn_favoriteItemWrap">
      <div className="mn_leftColumn">
        <div className="mn_merchantLogoWrap">
          <img className="mn_merchantLogo" src={logoUrls._120x60} alt={name} />
        </div>
        {disclaimer && <div className="mn_disclaimer">{disclaimer}</div>}
      </div>
      <div className="mn_rightColumn">
        <div className="mn_favoriteIconWrap">
          <FavoriteIcon merchantId={id} merchantName={name} />
        </div>
        <ExtraRewardsPill rebate={rebate} label={extraRewardsName} />
        <MerchantRebateV2 {...rebate} {...rebateOptions} />
        <ReadMore text={assets.text} moreLinkText="More" maxTextLength={80} />
        <div className="mn_couponCodeWrap">
          { couponCode &&
            <>
              <span className="mn_couponCodeLabel">{codeText || 'Use code:'} </span>
              <p className="mn_couponCode">{couponCode}</p>
            </>
          }
        </div>
        <div className="mn_expireWrap">
          <span className="mn_expire">
            {isOngoing ? <>Ongoing</> : <>Valid thru {expiresToDisplay}</>}
          </span>
        </div>
        <MerchantClickUrlLink className="mn_button" merchant={merchant} />
      </div>
    </div>
  );
}

export default HorizontalOffer;
